"use strict";
/* eslint-disable quotes */
const en = require('./en');
const intl = require('@lemonone/intl/lib/de');
module.exports = Object.assign({}, en, intl, {
    '@lemonone/components/TextArea:placeholder': 'Nachricht',
    '@lemonone/components/Uploader:reupload': 'Erneut hochladen',
    '@lemonone/components/Offer:distance': '{distance} km, {duration} Min. von Deiner Adresse entfernt',
    '@lemonone/components/Offer:earnings': 'Du verdienst: {earnings}',
    '@lemonone/components/Offer:compensationContract': '<bold>inklusive</bold> Reisekostenerstattung gemäß §2 deines Vertrages, sonst §13 der <terms>AGB</terms>',
    '@lemonone/components/Offer:compensationContract:text': '*inklusive* Reisekostenerstattung gemäß §2 deines Vertrages, sonst §13 der AGB ({terms})',
    '@lemonone/components/Offer:equipment': 'Mindestanforderung',
    '@lemonone/components/Offer:accept': 'Fotoshooting annehmen',
    '@lemonone/components/Offer:youNeedToProduce': 'Benötigt werden',
    '@lemonone/components/MoreShootsBanner:wantToSeeMore': 'Mehr verdienen?',
    '@lemonone/components/MoreShootsBanner:seeOtherShoots': 'Siehe andere Fotoshootings in deiner Nähe <here>hier</here>',
    '@lemonone/components/MoreShootsBanner:seeOtherShoots:text': 'Siehe andere Fotoshootings in deiner Nähe hier ({here})',
    '@lemonone/components/ShootRating:title': 'Bitte bewerten Sie Ihr Fotoshooting (Typeform)'
});
//# sourceMappingURL=de.js.map